export default "__VITE_ASSET__e076fccb__"